const StickyHeader = (header, attributes) => {
  const root = document.documentElement;
  const headerInner = header.querySelector('.header__inner');

  if (!headerInner) {
    throw new Error('Header inner element not found');
  }

  const { headerHidden, stickyHeaderActive } = attributes;
  const { delayHide, delayShow, mainHeaderHeight, mobileHeaderHeight } = headerInner.dataset;

  const initialState = {
    lastScrollY: 0,
    ticking: false,
    hideTimeout: null,
    scrollThreshold: 10,
    delayHide: delayHide || 50,
    delayShow: delayShow || 750,
    offset: window.innerWidth > 991 ? mainHeaderHeight : mobileHeaderHeight,
  };

  let state = { ...initialState };

  const setInitialState = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > state.offset) {
      updateHeader(true);

      setTimeout(() => {
        root.removeAttribute(headerHidden);
      }, delayShow);
    }
  };

  const updateHeader = (forceHide = false) => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > state.offset) {
      root.setAttribute(stickyHeaderActive, '');

      if (forceHide || currentScrollY > state.lastScrollY + state.scrollThreshold) {
        // root.setAttribute(headerHidden, '');
        // clearTimeout(state.hideTimeout);
      } else if (currentScrollY < state.lastScrollY - state.scrollThreshold) {
        root.removeAttribute(headerHidden);
        clearTimeout(state.hideTimeout);
      }
    } else {
      root.removeAttribute(stickyHeaderActive);
      root.removeAttribute(headerHidden);
    }

    state.lastScrollY = currentScrollY;
    state.ticking = false;
  };

  const headerOnScroll = () => {    
    if (!state.ticking) {
      window.requestAnimationFrame(() => {
        updateHeader();
        state.ticking = false;
      });

      state.ticking = true;
    }

    clearTimeout(state.hideTimeout);

    state.hideTimeout = setTimeout(() => {
      root.removeAttribute(headerHidden);
    }, state.delayShow);
  };

  const init = () => {
    setInitialState();
  };

  return { init, headerOnScroll };
};

export default StickyHeader;
